import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'RRToDateFormat',
})
export class RRToDateFormatPipe implements PipeTransform {
  transform(value: any, _args?: any): string {
    if (value) {
      const newdate: Date = new Date(value * 1000);
      value = this.getFormatedDate(newdate);
    }
    return value;
  }

  getFormatedDate(dateToFormat: Date): string {
    if (dateToFormat instanceof Date && isNaN(dateToFormat.getTime())) {
      return '';
    }

    const month = dateToFormat.getMonth() + 1;
    const day = dateToFormat.getDate();
    const year = dateToFormat.getFullYear();
    const hours = dateToFormat.getHours();
    const minutes = dateToFormat.getMinutes();
    // var ampm = hours >= 12 ? 'PM' : 'AM';
    // hours = hours % 12;
    // hours = hours ? hours : 12; // the hour '0' should be '12'
    const addLeadingZeroMinutes = minutes < 10 ? '0' : '';
    const addLeadingZeroHours = hours < 10 ? '0' : '';
    const addLeadingZeroMonth = month < 10 ? '0' : '';
    const addLeadingZeroDay = day < 10 ? '0' : '';
    return (
      year +
      '-' +
      addLeadingZeroMonth +
      month +
      '-' +
      addLeadingZeroDay +
      day +
      ' ' +
      addLeadingZeroHours +
      hours +
      ':' +
      addLeadingZeroMinutes +
      minutes
    );
  }
}
